// extracted by mini-css-extract-plugin
module.exports = {"maturityNote":"MetricsSection-maturityNote-1tJLYH","filter":"MetricsSection-filter-2wvGH1"};